const CONTAINER_ID = 'vbs-modal-container';

/**
 * Portal target for modals.
 *
 * It lives on `document.body` rather than inside the app's own tree so modals
 * overlay everything, including any host chrome when Studio is embedded via
 * `<vbs-console>`. A host that wants to place it itself can put an element with
 * this id in the page and it will be used as-is.
 *
 * Resolved at import time, which is why it is created on demand: the element
 * only exists in Studio's own `index.html`, and this module is evaluated well
 * before an embedding host has had a chance to add one.
 */
const resolveContainer = (): HTMLElement => {
    const existing = document.querySelector<HTMLElement>(`#${CONTAINER_ID}`);

    if (existing) {
        return existing;
    }

    const created = document.createElement('div');
    created.id = CONTAINER_ID;
    document.body.appendChild(created);

    return created;
};

export default resolveContainer();
